import './TextArea.css';
export default {
    "root": "TextArea_root__8bsug",
    "characterCounter": "TextArea_characterCounter__8bsug"
};
